'use strict';

//myPara.setAttribute("id", "id_you_like");

// let formmo = document.getElementsByTagName('form');

//document.getElementById("search-form").id = "search-form-mobile";



export function calculateFilterMarkers(form) {
    const values = [];

    if (form.elements['all_markers'].checked) {
        return (feature) => true;
    } else {
        const checkboxes = form.querySelectorAll('input[type=checkbox][name=selett]');
        checkboxes.forEach(checkbox => {
            if (checkbox.value > 0 && checkbox.checked) {
                values.push(checkbox.value);
            }
        })
    }

    return (feature) => feature.properties && values.indexOf(feature.properties['numero']) > -1;
}

export function clearSearchBox() {
    const form = document.getElementById('search-form');
    if (form && form.elements['searchText']) {
        form.elements['searchText'].value = '';
    }
}

export function clearCheckBoxes() {
    const form = document.getElementById('checkboxes');
    if (form) {
        const checkboxes = form.querySelectorAll('input[type=checkbox]');
        checkboxes.forEach(checkbox => {
            checkbox.checked = false;
        });
    }
}
export function clearCheckBoxesH() {
    const hform = document.getElementById('hcheckboxes');
    if (hform) {
        const hcheckboxes = hform.querySelectorAll('input[type=checkbox]');
        hcheckboxes.forEach(checkbox => {
            checkbox.checked = false;
        });
    }
}

export function initCheckboxes(layer, calculateFilterFunc, selector) {
    const form = document.getElementById('checkboxes');
    
    if (!selector) selector = '[type=checkbox]';
    
    form.querySelectorAll(selector).forEach(checkbox => {
        if (checkbox.initedChange) return;
        
        checkbox.addEventListener('change', function () {
            layer.setFilter(calculateFilterFunc(form));
            clearSearchBox();
        });
        checkbox.initedChange = true;
    });        
}

/*Solo per Skyrim con gli Holds*/
export function initCheckboxesH(layer, calculateFilterFunc, selector) {
    const hform = document.getElementById('hcheckboxes');
    
    if (!selector) selector = '[type=checkbox]';
    
    hform.querySelectorAll(selector).forEach(checkbox => {
        if (checkbox.initedChange) return;
        
        checkbox.addEventListener('change', function () {
            layer.setFilter(calculateFilterFunc(hform));
            clearSearchBox();
        });
        checkbox.initedChange = true;
    });    
    const form = document.getElementById('checkboxes');
    
    if (!selector) selector = '[type=checkbox]';
    
    form.querySelectorAll(selector).forEach(checkbox => {
        if (checkbox.initedChange) return;
        
        checkbox.addEventListener('change', function () {
            layer.setFilter(calculateFilterFunc(form));
            clearSearchBox();
        });
        checkbox.initedChange = true;
    });        
        
}

function searchByText(name, layerMarkers) {
    const filterFunc = (feature) => feature.properties && feature.properties.name == name;
    filterFunc.zoomAfterSearch = true;
    clearCheckBoxes();

    const form = document.getElementById('checkboxes');
    if (form) {
        const submitEvent = new Event('change', {
            'bubbles'    : true, // Whether the event will bubble up through the DOM or not
            'cancelable' : true  // Whether the event may be canceled or not
        });
        form.dispatchEvent(submitEvent);
    }

    layerMarkers.setFilter(filterFunc);
}

export function initSearchBox(layerMarkers) {
    layerMarkers.addListener('loaded', () => {
        $("#search-form [name=searchText]").autocomplete({
            source: layerMarkers.autoCompleteList,
            minLength: 2
        });
    });

    const form = document.getElementById('search-form');
    form.addEventListener('submit', (event) => {
        event.preventDefault();
        searchByText(form.elements['searchText'].value, layerMarkers);
    });
    
    form.submit = () => {
        searchByText(form.elements['searchText'].value, layerMarkers);
    };

    form.elements['searchText'].addEventListener('keyup', (event) => {
        if (event.keyCode == 13) {
            searchByText(form.elements['searchText'].value, layerMarkers)
        }
    });
}
